import { FieldBase } from '@vendasta/store';

export enum OrderType {
  ADDON = 'ADDON',
  APPLICATION = 'APPLICATION',
}

export interface Order {
  appId: string;
  parentAppId: string;
  businessId: string;
  name: string;
  type: OrderType;
  commonFields: FieldBase<any>[];
  customFields: FieldBase<any>[];
  usesOrderForm: boolean;
  editionId?: string;
}

export interface ActivationResult {
  appId: string;
  editionId?: string;
  parentAppId?: string;
  name: string;
  businessId: string;
  isSuccess?: boolean;
  errorMessage?: string;
  error?: Error;
}
